export const ADMIN_ARTICLES_EDIT_ROUTE_NAME = Symbol('admin.articles.edit');
export const ADMIN_ARTICLES_CREATE_ROUTE_NAME = Symbol('admin.articles.create');

export const ARTICLES_SAVE_URL = 'admin/articles/:id';
export const ARTICLES_SAVE_MUTATION_KEY = 'articles.save';
